module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stars",
    class: ['stars-' + _vm.size, 'stars-' + _vm.theme]
  }, _vm._l((_vm.stars), function(item, index) {
    return _c('button', {
      staticClass: "star",
      class: [
        index + 1 <= _vm.scoreSelf ? 'star-check' : ''
      ],
      style: ({
        opacity: index + 1 <= _vm.scoreSelf && _vm.theme == 'circle' ? (index + 1) / _vm.score : 1
      }),
      on: {
        "click": function($event) {
          _vm.changeScore(index + 1)
        }
      }
    }, [(_vm.theme == 'default') ? _c('i', {
      staticClass: "icon iconfont icon-favorfill"
    }) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cbf960e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stars/stars.vue
// module id = 246
// module chunks = 27